export default __webpack_public_path__ + "static/media/map-africa.d38cfb67.jpg";